import { render, staticRenderFns } from "./TsTravel.vue?vue&type=template&id=45589998&scoped=true"
import script from "./TsTravel.vue?vue&type=script&lang=js"
export * from "./TsTravel.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "45589998",
  null
  
)

export default component.exports